

<!-- <div class="director-landing-container"> -->
<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" fxFlexFill>
    <div fxFlex="initial">
        <app-admin-device-setup></app-admin-device-setup>  
    </div>

    <div fxFlex="initial">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
            
            <div fxFlex="initial">
                <button mat-raised-button type="button" (click)="getBrowserInfo()">GET BROWSER INFO</button>
            </div>

            <div fxFlex="initial">
                <button mat-raised-button type="button" (click)="logout()"
                    style="width: 100%; background-color: #ffce00;">
                    LOGOUT
                </button>
            </div>

        </div>
    </div> 

</div>


<!-- 
<div>
    <app-admin-device-setup></app-admin-device-setup>  
</div>
  
<div style="margin: 20px 0px;">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
        
        <div fxFlex="initial">
            <button mat-raised-button type="button" (click)="getBrowserInfo()">GET BROWSER INFO</button>
        </div>

        <div fxFlex="initial">
            <button mat-raised-button type="button" (click)="logout()"
                style="width: 100%; background-color: #ffce00;">
                LOGOUT
            </button>
        </div>

    </div>
</div> 
-->
